// plugins/fontawesome.ts
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Add solid and brand icons as needed
import {
  faUser,
  faEnvelope,
  faVideo,
  faBookOpen,
  faCircleCheck,
  faWallet,
  faHandshake,
  faFileInvoice,
  faHandHoldingHeart,
  faReceipt,
  faChartPie,
  faUserTie
} from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub, faTwitter } from '@fortawesome/free-brands-svg-icons';
library.add(
  faUser,
  faEnvelope,
  faLinkedin,
  faGithub,
  faTwitter,
  faVideo,
  faBookOpen,
  faCircleCheck,
  faWallet,
  faHandshake,
  faFileInvoice,
  faHandHoldingHeart,
  faReceipt,
  faChartPie,
  faUserTie
);

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.component('FontAwesomeIcon', FontAwesomeIcon);
});
